import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-redo-gray",
  "use": "icon-redo-gray-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-redo-gray\"><path d=\"M576 248.384l0-248.384 384 384-384 384 0-253.824c-446.752-10.496-427.584 303.776-313.856 509.824-280.704-303.424-221.088-789.568 313.856-775.616z\" fill=\"#515151\" p-id=\"5517\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol